import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priority'
})
export class PriorityPipe implements PipeTransform {

  allPriority = [
    { name: 'Hitno', label: 0 },
    { name: 'Regularno', label: 1 },
    { name: 'Lager', label: 2 },
  ];

  transform(value: number): string {
    const priority = this.allPriority.find(priority => priority.label === value).name
    return priority;
  }

}
